module.exports = __webpack_public_path__ + "img/mobile.60368a8e.png";